import { ROUTE_SPORTSBOOK } from '../router/constants.js';

const MARKETPLACE_GLOBAL_MENU_TITLE = 'MARKETPLACE_GLOBAL_MENU_TITLE';
const MARKETPLACE_GLOBAL_MENU_SUB_TITLE = 'MARKETPLACE_GLOBAL_MENU_SUB_TITLE';
const MARKETPLACE_DETAIL_BONUS_VALID_PRODUCTS = 'MARKETPLACE_DETAIL_BONUS_VALID_PRODUCTS';
const MARKETPLACE_DETAIL_BONUS_CLAIM_UNTIL = 'MARKETPLACE_DETAIL_BONUS_CLAIM_UNTIL';
const MARKETPLACE_DETAIL_BONUS_DAYS_TO_PLAY = 'MARKETPLACE_DETAIL_BONUS_DAYS_TO_PLAY';
const MARKETPLACE_DETAIL_BONUS_MIN_AMOUNT = 'MARKETPLACE_DETAIL_BONUS_MIN_AMOUNT';
const MARKETPLACE_DETAIL_BONUS_MAX_AMOUNT = 'MARKETPLACE_DETAIL_BONUS_MAX_AMOUNT';
const MARKETPLACE_DETAIL_BONUS_PERCENTAGE = 'MARKETPLACE_DETAIL_BONUS_PERCENTAGE';
const MARKETPLACE_DETAIL_BONUS_AMOUNT = 'MARKETPLACE_DETAIL_BONUS_AMOUNT';
const MARKETPLACE_GET_BONUS = 'MARKETPLACE_GET_BONUS';
const BONUS_MIN_ODDS = 'BONUS_MIN_ODDS';
const BONUS_MAX_ODDS = 'BONUS_MAX_ODDS';
const BONUS_MIN_COMBINATIONS = 'BONUS_MIN_COMBINATIONS';
const BONUS_MAX_COMBINATIONS = 'BONUS_MAX_COMBINATIONS';
const BONUS_MIN_STAKE = 'BONUS_MIN_STAKE';
const BONUS_MAX_STAKE = 'BONUS_MAX_STAKE';
const BONUS_BOOST_PERCENTAGE = 'BONUS_BOOST_PERCENTAGE';
const MARKETPLACE_BUY_WITH_POINTS = 'MARKETPLACE_BUY_WITH_POINTS';
const MARKETPLACE_BONUS_REQUIREMENTS = 'MARKETPLACE_BONUS_REQUIREMENTS';
const MARKETPLACE_CASINO_BONUS_REQUIREMENTS = 'MARKETPLACE_CASINO_BONUS_REQUIREMENTS';
const MARKETPLACE_CASINO_BONUS_REQUIREMENT_X_FACTOR = 'MARKETPLACE_CASINO_BONUS_REQUIREMENT_X_FACTOR';
const MARKETPLACE_FILTER_TABS_SHOP = 'MARKETPLACE_FILTER_TABS_SHOP';
const MARKETPLACE_FILTER_TABS_PROMOTIONS = 'MARKETPLACE_FILTER_TABS_PROMOTIONS';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_HEADER = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_HEADER';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_TEXT = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_TEXT';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_BALANCE = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_BALANCE';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_POINTS = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_POINTS';
const MARKETPLACE_DETAIL_CONTINUE_SHOPPING_BUTTON = 'MARKETPLACE_DETAIL_CONTINUE_SHOPPING_BUTTON';
const MARKETPLACE_DETAIL_RETURN_TO_PROMOTIONS = 'MARKETPLACE_DETAIL_RETURN_TO_PROMOTIONS';
const MARKETPLACE_DETAIL_PLAY_FREEBET_BUTTON = 'MARKETPLACE_DETAIL_PLAY_FREEBET_BUTTON';
const MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER = 'MARKETPLACE_MONEY_BONUS_REDEEM_SUCCESS_HEADER';
const MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT = 'MARKETPLACE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT';
const MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE = 'MARKETPLACE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE';
const MARKETPLACE_DETAIL_FREESPIN_ADDED_MESSAGE = 'MARKETPLACE_DETAIL_FREESPIN_ADDED_MESSAGE';
const MARKETPLACE_DETAIL_PLAY_FREESPIN_BUTTON = 'MARKETPLACE_DETAIL_PLAY_FREESPIN_BUTTON';
const MARKETPLACE_DETAIL_FREEBET_ADDED_MESSAGE = 'MARKETPLACE_DETAIL_FREEBET_ADDED_MESSAGE';
const MARKETPLACE_DETAIL_SUCCESS_MESSAGE = 'MARKETPLACE_DETAIL_SUCCESS_MESSAGE';
const MARKETPLACE_DETAIL_CAMPAIGN_ACCESS_ADDED_MESSAGE = 'MARKETPLACE_DETAIL_CAMPAIGN_ACCESS_ADDED_MESSAGE';
const MARKETPLACE_LOTTERY_SUCCESSFUL_ENTRY_TEXT = 'MARKETPLACE_LOTTERY_SUCCESSFUL_ENTRY_TEXT';
const MARKETPLACE_DETAIL_ITEM_NOT_FOUND = 'MARKETPLACE_DETAIL_ITEM_NOT_FOUND';
const MARKETPLACE_DETAIL_ITEM_NOT_FOUND_DESCRIPTION = 'MARKETPLACE_DETAIL_ITEM_NOT_FOUND_DESCRIPTION';
const MARKETPLACE_BONUS_TURNOVER_TIMES_DEPOSIT = 'MARKETPLACE_BONUS_TURNOVER_TIMES_DEPOSIT';
const MARKETPLACE_BONUS_TURNOVER_TIMES_FMB = 'MARKETPLACE_BONUS_TURNOVER_TIMES_FMB';
const MARKETPLACE_SPORTS_BONUS_REQUIREMENTS = 'MARKETPLACE_SPORTS_BONUS_REQUIREMENTS';
const MARKETPLACE_SPORTS_BONUS_REQUIREMENT_X_FACTOR = 'MARKETPLACE_SPORTS_BONUS_REQUIREMENT_X_FACTOR';
const MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS = 'MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS';
const MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS =
	'MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS';
const MARKETPLACE_WAGERING_MULTIPLIER_TYPE = 'MARKETPLACE_WAGERING_MULTIPLIER_TYPE';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_HEADER = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_HEADER';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_SUBTITLE = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_SUBTITLE';
const MARKETPLACE_DETAIL_ERROR_SUPPORT = 'MARKETPLACE_ERROR_SUPPORT';
const MARKETPLACE_DETAIL_ERROR_SKIP_BONUS = 'MARKETPLACE_DETAIL_ERROR_SKIP';
const MARKETPLACE_DETAIL_ERROR_TRY_AGAIN = 'MARKETPLACE_DETAIL_ERROR_TRY_AGAIN';
const MARKETPLACE_THUNDERBITE_ITEM_TITLE = 'MARKETPLACE_THUNDERBITE_ITEM_TITLE';
const MARKETPLACE_THUNDERBITE_ITEM_DESCRIPTION = 'MARKETPLACE_THUNDERBITE_ITEM_DESCRIPTION';
const MARKETPLACE_THUNDERBITE_PROMO_IMG = 'MARKETPLACE_THUNDERBITE_PROMO_IMG';
const MARKETPLACE_THUNDERBITE_PAGE_EMPTY = 'MARKETPLACE_THUNDERBITE_PAGE_EMPTY';
const MARKETPLACE_SPLASHTECH_ITEM_TITLE = 'MARKETPLACE_SPLASHTECH_ITEM_TITLE';
const MARKETPLACE_SPLASHTECH_ITEM_CARD_TITLE = 'MARKETPLACE_SPLASHTECH_ITEM_CARD_TITLE';
const MARKETPLACE_SPLASHTECH_ITEM_CARD_SUBTITLE = 'MARKETPLACE_SPLASHTECH_ITEM_CARD_SUBTITLE';
const MARKETPLACE_SPLASHTECH_ITEM_DESCRIPTION = 'MARKETPLACE_SPLASHTECH_ITEM_DESCRIPTION';
const MARKETPLACE_SPLASHTECH_ITEM_TITLE_INELIGIBLE = 'MARKETPLACE_SPLASHTECH_ITEM_TITLE_INELIGIBLE';
const MARKETPLACE_SPLASHTECH_PROMO_IMG = 'MARKETPLACE_SPLASHTECH_PROMO_IMG';
const MARKETPLACE_SPLASHTECH_PROMO_IMG_INELIGIBLE = 'MARKETPLACE_SPLASHTECH_PROMO_IMG_INELIGIBLE';
const MARKETPLACE_SPLASHTECH_PAGE_EMPTY = 'MARKETPLACE_SPLASHTECH_PAGE_EMPTY';
const MARKETPLACE_DETAIL_FREESPIN_GAME_NAME = 'MARKETPLACE_DETAIL_FREESPIN_GAME_NAME';
const MARKETPLACE_DETAIL_AMOUNT_OF_FREESPINS = 'MARKETPLACE_DETAIL_AMOUNT_OF_FREESPINS';
const MARKETPLACE_SUCCESS_PLAY_NOW = 'MARKETPLACE_SUCCESS_PLAY_NOW';
const MARKETPLACE_DETAIL_MESSAGE_BONUS_FREE_BET = 'MARKETPLACE_DETAIL_MESSAGE_BONUS_FREE_BET';
const MARKETPLACE_PLAYER_LEVELS = 'MARKETPLACE_PLAYER_LEVELS';
const MARKETPLACE_NL_U24_TITLE = 'MARKETPLACE_NL_U24_TITLE';
const MARKETPLACE_NL_U24_SUBTITLE = 'MARKETPLACE_NL_U24_SUBTITLE';
const MARKETPLACE_SPLIT_PAGE_TITLE = 'MARKETPLACE_SPLIT_PAGE_TITLE';
const MARKETPLACE_SPLIT_PAGE_PROMOTIONS_SUBTITLE = 'MARKETPLACE_SPLIT_PAGE_PROMOTIONS_SUBTITLE';
const MARKETPLACE_SPLIT_PAGE_MY_ACTIVITIES_SUBTITLE = 'MARKETPLACE_SPLIT_PAGE_MY_ACTIVITIES_SUBTITLE';
const MARKETPLACE_SPLIT_CASINO = 'MARKETPLACE_SPLIT_CASINO';
const MARKETPLACE_SPLIT_SPORTS = 'MARKETPLACE_SPLIT_SPORTS';
const MARKETPLACE_SPLIT_CASINO_PROMOTIONS = 'MARKETPLACE_SPLIT_CASINO_PROMOTIONS';
const MARKETPLACE_SPLIT_SPORTS_PROMOTIONS = 'MARKETPLACE_SPLIT_SPORTS_PROMOTIONS';
const MARKETPLACE_SPLIT_CASINO_ACTIVITIES = 'MARKETPLACE_SPLIT_CASINO_ACTIVITIES';
const MARKETPLACE_SPLIT_SPORTS_ACTIVITIES = 'MARKETPLACE_SPLIT_SPORTS_ACTIVITIES';
const MARKETPLACE_SELF_EXCLUDED_TITLE = 'MARKETPLACE_SELF_EXCLUDED_TITLE';
const MARKETPLACE_SELF_EXCLUDED_SUBTITLE = 'MARKETPLACE_SELF_EXCLUDED_SUBTITLE';
const MARKETPLACE_FREESPIN_WAGERING_REQUIREMENTS = 'MARKETPLACE_FREESPIN_WAGERING_REQUIREMENTS';
const MARKETPLACE_FREESPIN_WIN_AMOUNT = 'MARKETPLACE_FREESPIN_WIN_AMOUNT';
const MARKETPLACE_VALID_UNTIL = 'MARKETPLACE_VALID_UNTIL';
const MARKETPLACE_MY_ACTIVITIES_HISTORY_ALL = 'MARKETPLACE_MY_ACTIVITIES_HISTORY_ALL';
const MARKETPLACE_BONUS_DISCLAIMER = 'MARKETPLACE_BONUS_DISCLAIMER';

const TEXT_KEYS = [
	MARKETPLACE_GLOBAL_MENU_TITLE,
	MARKETPLACE_GLOBAL_MENU_SUB_TITLE,
	MARKETPLACE_DETAIL_BONUS_VALID_PRODUCTS,
	MARKETPLACE_DETAIL_BONUS_CLAIM_UNTIL,
	MARKETPLACE_DETAIL_BONUS_DAYS_TO_PLAY,
	MARKETPLACE_DETAIL_BONUS_MIN_AMOUNT,
	MARKETPLACE_DETAIL_BONUS_MAX_AMOUNT,
	MARKETPLACE_DETAIL_BONUS_PERCENTAGE,
	MARKETPLACE_DETAIL_BONUS_AMOUNT,
	MARKETPLACE_GET_BONUS,
	BONUS_MIN_ODDS,
	BONUS_MAX_ODDS,
	BONUS_MIN_COMBINATIONS,
	BONUS_MAX_COMBINATIONS,
	BONUS_MIN_STAKE,
	BONUS_MAX_STAKE,
	BONUS_BOOST_PERCENTAGE,
	MARKETPLACE_BUY_WITH_POINTS,
	MARKETPLACE_BONUS_REQUIREMENTS,
	MARKETPLACE_CASINO_BONUS_REQUIREMENTS,
	MARKETPLACE_CASINO_BONUS_REQUIREMENT_X_FACTOR,
	MARKETPLACE_FILTER_TABS_SHOP,
	MARKETPLACE_FILTER_TABS_PROMOTIONS,
	MARKETPLACE_DETAIL_ITEM_NOT_FOUND,
	MARKETPLACE_DETAIL_ITEM_NOT_FOUND_DESCRIPTION,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_HEADER,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_TEXT,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_BALANCE,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_POINTS,
	MARKETPLACE_DETAIL_CONTINUE_SHOPPING_BUTTON,
	MARKETPLACE_DETAIL_RETURN_TO_PROMOTIONS,
	MARKETPLACE_DETAIL_PLAY_FREEBET_BUTTON,
	MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER,
	MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT,
	MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE,
	MARKETPLACE_DETAIL_FREESPIN_ADDED_MESSAGE,
	MARKETPLACE_DETAIL_PLAY_FREESPIN_BUTTON,
	MARKETPLACE_DETAIL_FREEBET_ADDED_MESSAGE,
	MARKETPLACE_DETAIL_SUCCESS_MESSAGE,
	MARKETPLACE_LOTTERY_SUCCESSFUL_ENTRY_TEXT,
	MARKETPLACE_BONUS_TURNOVER_TIMES_DEPOSIT,
	MARKETPLACE_BONUS_TURNOVER_TIMES_FMB,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENTS,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENT_X_FACTOR,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS,
	MARKETPLACE_WAGERING_MULTIPLIER_TYPE,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_HEADER,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_SUBTITLE,
	MARKETPLACE_DETAIL_ERROR_SUPPORT,
	MARKETPLACE_DETAIL_ERROR_SKIP_BONUS,
	MARKETPLACE_DETAIL_ERROR_TRY_AGAIN,
	MARKETPLACE_THUNDERBITE_ITEM_TITLE,
	MARKETPLACE_THUNDERBITE_ITEM_DESCRIPTION,
	MARKETPLACE_THUNDERBITE_PROMO_IMG,
	MARKETPLACE_SPLASHTECH_ITEM_TITLE,
	MARKETPLACE_SPLASHTECH_ITEM_CARD_TITLE,
	MARKETPLACE_SPLASHTECH_ITEM_CARD_SUBTITLE,
	MARKETPLACE_SPLASHTECH_ITEM_DESCRIPTION,
	MARKETPLACE_SPLASHTECH_PROMO_IMG,
	MARKETPLACE_THUNDERBITE_PAGE_EMPTY,
	MARKETPLACE_SPLASHTECH_ITEM_TITLE_INELIGIBLE,
	MARKETPLACE_SPLASHTECH_PROMO_IMG_INELIGIBLE,
	MARKETPLACE_SPLASHTECH_PAGE_EMPTY,
	MARKETPLACE_DETAIL_FREESPIN_GAME_NAME,
	MARKETPLACE_DETAIL_AMOUNT_OF_FREESPINS,
	MARKETPLACE_SUCCESS_PLAY_NOW,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_FREE_BET,
	MARKETPLACE_PLAYER_LEVELS,
	MARKETPLACE_NL_U24_TITLE,
	MARKETPLACE_NL_U24_SUBTITLE,
	MARKETPLACE_SPLIT_PAGE_TITLE,
	MARKETPLACE_SPLIT_PAGE_PROMOTIONS_SUBTITLE,
	MARKETPLACE_SPLIT_PAGE_MY_ACTIVITIES_SUBTITLE,
	MARKETPLACE_SPLIT_CASINO,
	MARKETPLACE_SPLIT_SPORTS,
	MARKETPLACE_SPLIT_CASINO_PROMOTIONS,
	MARKETPLACE_SPLIT_SPORTS_PROMOTIONS,
	MARKETPLACE_SPLIT_CASINO_ACTIVITIES,
	MARKETPLACE_SPLIT_SPORTS_ACTIVITIES,
	MARKETPLACE_SELF_EXCLUDED_TITLE,
	MARKETPLACE_SELF_EXCLUDED_SUBTITLE,
	MARKETPLACE_FREESPIN_WAGERING_REQUIREMENTS,
	MARKETPLACE_FREESPIN_WIN_AMOUNT,
	MARKETPLACE_VALID_UNTIL,
	MARKETPLACE_MY_ACTIVITIES_HISTORY_ALL,
	MARKETPLACE_BONUS_DISCLAIMER
];
const MARKETPLACE_ROUTES = ['promotions', 'shop'];

export {
	MARKETPLACE_GLOBAL_MENU_TITLE,
	MARKETPLACE_GLOBAL_MENU_SUB_TITLE,
	MARKETPLACE_DETAIL_BONUS_VALID_PRODUCTS,
	MARKETPLACE_DETAIL_BONUS_CLAIM_UNTIL,
	MARKETPLACE_DETAIL_BONUS_DAYS_TO_PLAY,
	MARKETPLACE_DETAIL_BONUS_MIN_AMOUNT,
	MARKETPLACE_DETAIL_BONUS_MAX_AMOUNT,
	MARKETPLACE_DETAIL_BONUS_PERCENTAGE,
	MARKETPLACE_DETAIL_BONUS_AMOUNT,
	MARKETPLACE_GET_BONUS,
	BONUS_MIN_ODDS,
	BONUS_MAX_ODDS,
	BONUS_MIN_COMBINATIONS,
	BONUS_MAX_COMBINATIONS,
	BONUS_MIN_STAKE,
	BONUS_MAX_STAKE,
	BONUS_BOOST_PERCENTAGE,
	MARKETPLACE_BUY_WITH_POINTS,
	MARKETPLACE_BONUS_REQUIREMENTS,
	MARKETPLACE_CASINO_BONUS_REQUIREMENTS,
	MARKETPLACE_CASINO_BONUS_REQUIREMENT_X_FACTOR,
	MARKETPLACE_FILTER_TABS_SHOP,
	MARKETPLACE_FILTER_TABS_PROMOTIONS,
	TEXT_KEYS,
	MARKETPLACE_ROUTES,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_HEADER,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_TEXT,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_BALANCE,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_SUCCESS_POINTS,
	MARKETPLACE_DETAIL_CONTINUE_SHOPPING_BUTTON,
	MARKETPLACE_DETAIL_RETURN_TO_PROMOTIONS,
	MARKETPLACE_DETAIL_PLAY_FREEBET_BUTTON,
	MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER,
	MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT,
	MARKETPLACE_FREE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE,
	MARKETPLACE_DETAIL_FREESPIN_ADDED_MESSAGE,
	MARKETPLACE_DETAIL_PLAY_FREESPIN_BUTTON,
	MARKETPLACE_DETAIL_FREEBET_ADDED_MESSAGE,
	MARKETPLACE_DETAIL_SUCCESS_MESSAGE,
	MARKETPLACE_LOTTERY_SUCCESSFUL_ENTRY_TEXT,
	MARKETPLACE_DETAIL_CAMPAIGN_ACCESS_ADDED_MESSAGE,
	MARKETPLACE_BONUS_TURNOVER_TIMES_DEPOSIT,
	MARKETPLACE_BONUS_TURNOVER_TIMES_FMB,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENTS,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENT_X_FACTOR,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS,
	MARKETPLACE_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS,
	MARKETPLACE_WAGERING_MULTIPLIER_TYPE,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_HEADER,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_ERROR_SUBTITLE,
	MARKETPLACE_DETAIL_ERROR_SUPPORT,
	MARKETPLACE_DETAIL_ERROR_SKIP_BONUS,
	MARKETPLACE_DETAIL_ERROR_TRY_AGAIN,
	MARKETPLACE_THUNDERBITE_ITEM_TITLE,
	MARKETPLACE_THUNDERBITE_ITEM_DESCRIPTION,
	MARKETPLACE_THUNDERBITE_PROMO_IMG,
	MARKETPLACE_THUNDERBITE_PAGE_EMPTY,
	MARKETPLACE_SPLASHTECH_ITEM_TITLE,
	MARKETPLACE_SPLASHTECH_ITEM_CARD_TITLE,
	MARKETPLACE_SPLASHTECH_ITEM_CARD_SUBTITLE,
	MARKETPLACE_SPLASHTECH_ITEM_DESCRIPTION,
	MARKETPLACE_SPLASHTECH_PROMO_IMG,
	MARKETPLACE_SPLASHTECH_ITEM_TITLE_INELIGIBLE,
	MARKETPLACE_SPLASHTECH_PROMO_IMG_INELIGIBLE,
	MARKETPLACE_SPLASHTECH_PAGE_EMPTY,
	MARKETPLACE_DETAIL_FREESPIN_GAME_NAME,
	MARKETPLACE_DETAIL_AMOUNT_OF_FREESPINS,
	MARKETPLACE_SUCCESS_PLAY_NOW,
	MARKETPLACE_DETAIL_MESSAGE_BONUS_FREE_BET,
	MARKETPLACE_PLAYER_LEVELS,
	MARKETPLACE_NL_U24_TITLE,
	MARKETPLACE_NL_U24_SUBTITLE,
	MARKETPLACE_SPLIT_PAGE_TITLE,
	MARKETPLACE_SPLIT_PAGE_PROMOTIONS_SUBTITLE,
	MARKETPLACE_SPLIT_PAGE_MY_ACTIVITIES_SUBTITLE,
	MARKETPLACE_SPLIT_CASINO,
	MARKETPLACE_SPLIT_SPORTS,
	MARKETPLACE_SPLIT_CASINO_PROMOTIONS,
	MARKETPLACE_SPLIT_SPORTS_PROMOTIONS,
	MARKETPLACE_SPLIT_CASINO_ACTIVITIES,
	MARKETPLACE_SPLIT_SPORTS_ACTIVITIES,
	MARKETPLACE_SELF_EXCLUDED_TITLE,
	MARKETPLACE_SELF_EXCLUDED_SUBTITLE,
	MARKETPLACE_FREESPIN_WAGERING_REQUIREMENTS,
	MARKETPLACE_FREESPIN_WIN_AMOUNT,
	MARKETPLACE_VALID_UNTIL,
	MARKETPLACE_MY_ACTIVITIES_HISTORY_ALL,
	MARKETPLACE_BONUS_DISCLAIMER
};

export const CasinoButton = {
	onClick: ({ casinoRoute }) => {
		window.location = casinoRoute;
	},
	textKey: MARKETPLACE_SUCCESS_PLAY_NOW
};

export const SportsbookButton = {
	onClick: () => {
		window.location = ROUTE_SPORTSBOOK;
	},
	textKey: MARKETPLACE_SUCCESS_PLAY_NOW
};

export const getButtonsForProducts = (isCasinoBonus = true, isSportsbookBonus = false) => {
	const buttons = [];
	if (isCasinoBonus) {
		buttons.push(CasinoButton);
		return buttons;
	}
	if (isSportsbookBonus) {
		buttons.push(SportsbookButton);
		return buttons;
	}
	return buttons;
};
